module.exports = __webpack_public_path__ + "img/rtf-file.41edca1b.svg";